import EDC from '@/components/games/shared/globals';
import store from '@/store/index';
import { requestRoot } from '@/axios';

/**
 *
 */
EDC.Games.Badges.Scenes.Main = function () {
};
/**
 *
 */
EDC.Games.Badges.Scenes.Main.prototype.create = function () {
  const gameWidth = this.game.config.width;
  const gameHeight = this.game.config.height;

  const image = this.add.image(gameWidth / 2, gameHeight / 2, 'background');
  const scaleX = this.cameras.main.width / image.width;
  const scaleY = this.cameras.main.height / image.height;
  const scale = Math.max(scaleX, scaleY);
  image.setScale(scale).setScrollFactor(0);

  const activeProfile = store.getters['children/activeChildProfile'];
  requestRoot.get(`/game/mastered/${activeProfile.id}`)
    .then((response) => {
      const metrics = response.data;
      const math = metrics.filter(game => game.category === 'mathematics');
      const language = metrics.filter(game => game.category === 'language');
      const logic = metrics.filter(game => game.category === 'logic');
      const general = metrics.filter(game => game.category === 'general');

      this.add.image(960, 200, 'title').setScale(0.5);
      this.add.image(960, 310, 'title-text').setScale(0.5);

      if (math.length === 0) {
        this.add.image(320, 440, 'crystal-0').setScale(0.55);
        this.add.image(320, 405, 'number-0-alt').setScale(0.55);
      } else if (math.length < 10) {
        this.add.image(320, 440, 'crystal-1').setScale(0.55);
        this.add.image(320, 405, `number-${math.length}`).setScale(0.55);
      } else {
        this.add.image(320, 440, 'crystal-1').setScale(0.55);
        const digit1 = math.length.toString().charAt(0);
        const digit2 = math.length.toString().charAt(1);
        this.add.image(260, 405, `number-${digit1}`).setScale(0.55);
        this.add.image(400, 405, `number-${digit2}`).setScale(0.55);
        this.add.image(320, 570, 'star').setScale(0.5);
      }

      if (language.length === 0) {
        this.add.image(725, 650, 'crystal-0').setScale(0.55);
        this.add.image(730, 615, 'number-0-alt').setScale(0.55);
      } else if (language.length < 10) {
        this.add.image(725, 650, 'crystal-2').setScale(0.55);
        this.add.image(730, 615, `number-${language.length}`).setScale(0.55);
      } else {
        this.add.image(725, 650, 'crystal-2').setScale(0.55);
        const digit1 = language.length.toString().charAt(0);
        const digit2 = language.length.toString().charAt(1);
        this.add.image(665, 615, `number-${digit1}`).setScale(0.55);
        this.add.image(805, 615, `number-${digit2}`).setScale(0.55);
        this.add.image(729, 780, 'star').setScale(0.5);
      }

      if (logic.length === 0) {
        this.add.image(1181, 650, 'crystal-0').setScale(0.55);
        this.add.image(1181, 615, 'number-0-alt').setScale(0.55);
      } else if (logic.length < 10) {
        this.add.image(1181, 650, 'crystal-3').setScale(0.55);
        this.add.image(1181, 615, `number-${logic.length}`).setScale(0.55);
      } else {
        this.add.image(1181, 650, 'crystal-3').setScale(0.55);
        const digit1 = logic.length.toString().charAt(0);
        const digit2 = logic.length.toString().charAt(1);
        this.add.image(1121, 615, `number-${digit1}`).setScale(0.55);
        this.add.image(1261, 615, `number-${digit2}`).setScale(0.55);
        this.add.image(1181, 780, 'star').setScale(0.5);
      }

      if (general.length === 0) {
        this.add.image(1578, 440, 'crystal-0').setScale(0.55);
        this.add.image(1578, 405, 'number-0-alt').setScale(0.55);
      } else if (general.length < 10) {
        this.add.image(1578, 440, 'crystal-4').setScale(0.55);
        this.add.image(1578, 405, `number-${general.length}`).setScale(0.55);
      } else {
        this.add.image(1578, 440, 'crystal-4').setScale(0.55);
        const digit1 = general.length.toString().charAt(0);
        const digit2 = general.length.toString().charAt(1);
        this.add.image(1508, 405, `number-${digit1}`).setScale(0.55);
        this.add.image(1658, 405, `number-${digit2}`).setScale(0.55);
        this.add.image(1578, 570, 'star').setScale(0.5);
      }

      this.add.image(320, 720, 'label-box').setScale(0.48);
      this.add.image(725, 930, 'label-box').setScale(0.48);
      this.add.image(1181, 930, 'label-box').setScale(0.48);
      this.add.image(1578, 720, 'label-box').setScale(0.48);

      this.add.image(320, 717, 'math-title').setScale(0.45);
      this.add.image(730, 927, 'language-title').setScale(0.45);
      this.add.image(1181, 927, 'logic-title').setScale(0.45);
      this.add.image(1578, 717, 'general-title').setScale(0.45);
    }).catch(err => console.error(err));
};


export default EDC.Games.Badges.Scenes.Main;
